import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('MissionReward')
export class MissionReward {

  @JsonProperty('mission_reward_id', Number)
  missionRewardId: number = 0;

  @JsonProperty('start_date_timestamp', Number)
  startDateTimestamp: number = 0;

  @JsonProperty('end_date_timestamp', Number)
  endDateTimestamp: number = 0;

  @JsonProperty('currency_type', Number)
  currencyType: number = 0;

  @JsonProperty('currency_quantity', Number)
  currencyQuantity: number = 0;

  @JsonProperty('currency_ticket_cost', Number)
  currencyTicketCost: number = 0;

  @JsonProperty('points_required', Number)
  pointsRequired: number = 0;

  @JsonProperty('points_required_total', Number)
  pointsRequiredTotal: number = 0;
}
